module.exports = __webpack_public_path__ + "img/hand-thumbs-down-fill.28d5aee7.svg";